function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
// interpolates between a set of colors uzing a bezier spline
//

// @requires utils lab
import Color from '../Color.js';
import '../io/lab/index.js';
import scale from './scale.js';

// nth row of the pascal triangle
const binom_row = function (n) {
  let row = [1, 1];
  for (let i = 1; i < n; i++) {
    let newrow = [1];
    for (let j = 1; j <= row.length; j++) {
      newrow[j] = (row[j] || 0) + row[j - 1];
    }
    row = newrow;
  }
  return row;
};
const bezier = function (colors) {
  let I, lab0, lab1, lab2;
  colors = colors.map(c => new Color(c));
  if (colors.length === 2) {
    // linear interpolation
    var _colors$map = colors.map(c => c.lab());
    var _colors$map2 = _slicedToArray(_colors$map, 2);
    lab0 = _colors$map2[0];
    lab1 = _colors$map2[1];
    I = function (t) {
      const lab = [0, 1, 2].map(i => lab0[i] + t * (lab1[i] - lab0[i]));
      return new Color(lab, 'lab');
    };
  } else if (colors.length === 3) {
    // quadratic bezier interpolation
    var _colors$map3 = colors.map(c => c.lab());
    var _colors$map4 = _slicedToArray(_colors$map3, 3);
    lab0 = _colors$map4[0];
    lab1 = _colors$map4[1];
    lab2 = _colors$map4[2];
    I = function (t) {
      const lab = [0, 1, 2].map(i => (1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
      return new Color(lab, 'lab');
    };
  } else if (colors.length === 4) {
    // cubic bezier interpolation
    let lab3;
    var _colors$map5 = colors.map(c => c.lab());
    var _colors$map6 = _slicedToArray(_colors$map5, 4);
    lab0 = _colors$map6[0];
    lab1 = _colors$map6[1];
    lab2 = _colors$map6[2];
    lab3 = _colors$map6[3];
    I = function (t) {
      const lab = [0, 1, 2].map(i => (1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
      return new Color(lab, 'lab');
    };
  } else if (colors.length >= 5) {
    // general case (degree n bezier)
    let labs, row, n;
    labs = colors.map(c => c.lab());
    n = colors.length - 1;
    row = binom_row(n);
    I = function (t) {
      const u = 1 - t;
      const lab = [0, 1, 2].map(i => labs.reduce((sum, el, j) => sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
      return new Color(lab, 'lab');
    };
  } else {
    throw new RangeError('No point in running bezier with only one color.');
  }
  return I;
};
export default colors => {
  const f = bezier(colors);
  f.scale = () => scale(f);
  return f;
};